import { ENDPOINTS } from "../../constant/routes";
import { request } from "../../services/requests";

export type SellerApplicationStatus = "pending" | "approved" | "no_account";

export interface SellerApplication {
  application_id: number;
  name: string;
  email: string;
  business_name: string;
  phone_number: string | null;
  business_description: string;
  country: string | null;
  submitted_at: string;
  user_id: string | null;
  username: string | null;
  status: SellerApplicationStatus;
}

export const getSellerApplications = (token: string) =>
  request(token).get<SellerApplication[]>(`${ENDPOINTS.SELLERS}/applications`);

/** Makes the applicant's account a seller and emails them. */
export const approveSellerApplication = (applicationId: number, token: string) =>
  request(token).post(`${ENDPOINTS.SELLERS}/applications/${applicationId}/approve`);
